// CheckedBulletList.tsx
import DoneIcon from "@mui/icons-material/Done"
import { Box, Typography } from "@mui/material"
import { Variant } from "@mui/material/styles/createTypography"
import { FC } from "react"

type CheckedBulletListProps = {
    items: string[]
    secondary?: boolean
    variant?: Variant
    fontWeight?: number | undefined
}

/**
 * Bullet point list with a check mark icon.
 */
const CheckMarkList: FC<CheckedBulletListProps> = ({
    items,
    secondary,
    variant,
    fontWeight,
}) => (
    <ul style={{ paddingLeft: 15 }}>
        {items.map((item) => (
            <Box
                key={item}
                component="li"
                mb={1}
                display="flex"
                alignItems="center"
                color={secondary ? "text.secondary" : "text.primary"}
            >
                <DoneIcon color="success" fontSize="small" />
                <Box ml={1}>
                    <Typography variant={variant} fontWeight={fontWeight}>
                        {item}
                    </Typography>
                </Box>
            </Box>
        ))}
    </ul>
)

CheckMarkList.defaultProps = {
    secondary: false,
    fontWeight: undefined,
    variant: "body1",
}

export default CheckMarkList
